// extracted by mini-css-extract-plugin
module.exports = {"container":"_3w-oQYD4","logo":"_1YgTnr3b","icon":"AUgqmc_x","text":"lLZNogBk m1","button":"_11CbEnmA"};